import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog, ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { cssClass } from '~src/style';

import { FlowParameter } from '../types/FlowParameters';
import { separateParameters } from '../utils/FlowParametersUtils';
import { FlowParametersDialogContent, FlowParametersSetParametersAction } from './FlowParametersDialogContent';

const rootClass = 'SetFlowParametersDialog';

const wrapper = cssClass(rootClass, 'wrapper', {
  $nest: {
    '& + div': {
      margin: '0 16px 16px 16px',
    }
  }
});

const promptClass = cssClass(rootClass, 'prompt', {
  padding: '12px 16px',
  borderBottom: '1px solid #ccc',
});

export function getSetFlowParametersDialog(flowName: string, parameters: FlowParameter[], callback: (map: {[key: string]: string}) => Promise<any>): Promise<any> {
  const props: SetFlowParametersDialogProps = {
    ...separateParameters(parameters),
    callback,
    flowName,
  };
  return displaySetFlowParametersDialog(props);
}

function onAction(props: SetFlowParametersDialogProps, state: SetFlowParametersDialogState) {
  return props.callback(state.parametersMap);
}

function isActionDisabled(props: SetFlowParametersDialogProps, state: SetFlowParametersDialogState): boolean {
  let isARequiredParameterUnset = false;
  props.requiredParameters.forEach(parameter => {
    if (state.parametersMap[parameter.id] === '') {
      isARequiredParameterUnset = true;
    }
  });
  return isARequiredParameterUnset;
}

function displaySetFlowParametersDialog(props: SetFlowParametersDialogProps): Promise<any> {
  const modalInstance = openReactActionDialog({
    title: Messages.flowParametersSetParametersTitle(),
    bodyComponent: SetFlowParametersDialog,
    initialBodyProps: props,
    initialDialogState: { parametersMap: {} },
    actionName: Messages.capability_execute_flow(),
    action: onAction,
    actionDisabled: isActionDisabled,
    dialogWidth: 600,
    dismissDialogOnActionFailed: false,
    showCloseButton: true,
    dialogBodyStyle: {padding: 0},
  });

  return modalInstance.result;
}

interface SetFlowParametersDialogProps {
  flowName: string;
  requiredParameters: FlowParameter[];
  additionalParameters: FlowParameter[];
  systemParameters: FlowParameter[];
  callback: (map: {[key: string]: string}) => Promise<any>;
}

interface SetFlowParametersDialogState {
  parametersMap: {[key: string]: string};
}

function SetFlowParametersDialog(props: ReactActionDialogBodyProps<SetFlowParametersDialogProps, SetFlowParametersDialogState>): JSX.Element {

  function actionHandler(action: FlowParametersSetParametersAction) {
    props.updateDialogState({
      parametersMap: action.payload,
    });
  }
  return (
    <div className={wrapper}>
      <div className={promptClass}>{Messages.flowParametersSetParametersForFlow({FLOW_NAME: props.flowName})}</div>
      <FlowParametersDialogContent
        requiredParameters={props.requiredParameters}
        additionalParameters={props.additionalParameters}
        systemParameters={props.systemParameters}
        isRunNow={true}
        actionHandler={actionHandler}
      />
    </div>
  );
}
